import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import License from "@/components/License";
import SessionExpire from "@/components/SessionExpire";
import Master from "@/components/Master";
import Home from "@/components/Home";
import Application from "@/components/Application";
import TransRequest from "@/components/TransRequest";
import TransSuccess from "@/components/TransSuccess";
import TransError from "@/components/TransError";
import ShortCourseFeedBack from "@/components/ShortCourseFeedBackChanged";

Vue.use(Router)

export default new Router({
  routes: [
    { path: "/", name: "Login", component: Login },
    { path: "/SessionExpire", name: "SessionExpire", component: SessionExpire },
    { path: "/License", name: "License", component: License },
    {
      path: "/Master", name: "Master", component: Master, children: [
        { path: "/Home", name: "Home", component: Home },
        { path: "/Application", name: "Application", component: Application },
        { path: "/TransRequest", name: "TransRequest", component: TransRequest },
        { path: "/TransSuccess", name: "TransSuccess", component: TransSuccess },
        { path: "/TransError", name: "TransError", component: TransError },
        { path: "/ShortCourseFeedBackChanged", name: "ShortCourseFeedBackChanged", component: ShortCourseFeedBack }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js